import {UserData as uData, Role, AppMetadata as aMetaData} from 'auth0';

export interface UserRoleLocation {
  locationId?: string | number,
  roles?: String[]
}

export interface AppMetadata extends aMetaData {
  tenantId?: string | number,
  locations?: UserRoleLocation[]
}

export interface UserInfoField {
  label: String,
  key?: String,
  type: String,
  options?: any,
  fields?: UserInfoField[],
  config?: any,
  validate?: String | Function
  name?: String,
  readonly?: Boolean,
  [propName: string]: any
  
}
export interface UserData extends uData {
  roles?: Role[]
}
export default class User {
  constructor (user?: UserData) {
    Object.assign(this, user || {})
  }
}